$(function(){

  $(document).on('click', '.condition_table_switch', function(){
      $('.condition_table').toggleClass('open');
  });

  $('.announcement-bar__message').click(function(){
    $('.announce_box').slideDown(300);
    $('.announce_message').append('<div class="announce_bg"></div>');
    $('.announce_bg').click(function(){
      $('.announce_box').slideUp(300);
    $(this).remove();
  });
  });


  $('.announce_close_btn').click(function(){
    $('.announce_bar').slideUp(300);
  });

});





// SPフィルター高さ調整

document.addEventListener("DOMContentLoaded", function(){

  const header = document.querySelector('.header');
  if(!header) return;

  const rect = header.getBoundingClientRect();
  const headerBottom = rect.bottom;

  document.querySelectorAll('.mobile-facets').forEach(el=>{
    el.style.top = headerBottom + "px";
    el.style.height = "calc(100vh - " + headerBottom + "px)";
  });

});